import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';
import QuoteDetail from '@system/config/quote-detail';
import CommonQuoteDetail from './CommonQuoteDetail';
import { QuoteDetailSearchFilter } from './DetailFilter/QuoteDetailSearchFilter';
import CartConfig from "@system/config/cart";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import NoResultContent from '../HomePageContent/NoResultContent';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Helper from 'src/support/Helper';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory'
const c = System.getParams();

//DT -hide info when pending Tab

const QuoteDetailTabsListing = (props) => {
    const [searchParams] = useSearchParams();
    const [QuoteDetailTabList__Component__Loader, Set_QuoteDetailTabList__Component__Loader] = useReduxState(searchParams.get(CommonQuoteDetail.param_key_QuoteDetailTabList) ? searchParams.get(CommonQuoteDetail.param_key_QuoteDetailTabList) : CommonQuoteDetail.default_component.param_value, CommonQuoteDetail.redux_key_QuoteDetailTabList);
    const [__check] = useAxiosIndicatorCheck();
    const quoteNumber = c.quote_number;
    const quoteProvisionalNumber = c.quoteProvisionalNumber;
    const __c_QuoteDetailTabList = c.__c_QuoteDetailTabList;
    const [{ get_current_quote_cart, get_selected_current_tab_data }, { fetch_quote_header_detail }, { select_all_quantity }] = useQuoteDetailStore();
    let [noResultForCheckout, setNoResultForCheckout] = useState(false);
    let [noResultForRFQ, setNoResultForRFQ] = useState(false);
    let [statusQuoteDetailTabList, setStatusQuoteDetailTabList] = useState(__c_QuoteDetailTabList);
    const [_check_p] = useCheckAuthPermissions();

    const quoteList = get_current_quote_cart();

    const currentTabDetail = CommonQuoteDetail.getCurrentActiveTabDetail(QuoteDetailTabList__Component__Loader);
    const currentTabList = currentTabDetail ? currentTabDetail.records : {};
    const currentTab = currentTabDetail?.api_query_param ? currentTabDetail?.api_query_param : 'A';
    const currentTabSlug = currentTabDetail?.slug ? currentTabDetail?.slug : 'Approved';
    const orderBlock = System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock;

    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    const inventory = inventoryList;
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const pricing = pricingList;

    useEffect(() => {
        async function fetchHere() {
            await fetch_quote_header_detail(quoteNumber, quoteProvisionalNumber);
        }
        fetchHere();

    }, []);

    useEffect(() => {
        if (noResultForCheckout === true) {
            setNoResultForCheckout(false)
        }

    }, [quoteList, currentTab]);

    const getActiveClass = (singleElement) => {
        if (CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader].param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        return QuoteDetail.getQuoteDetailTabsListRouteURL({
            ...c,
            [CommonQuoteDetail.param_key_QuoteDetailTabList]: singleElement.param_value
        });
    };

    const switchTab = async (url, chain_single) => {
        history.pushState('', '', url);
        Set_QuoteDetailTabList__Component__Loader(chain_single.param_value);
    };

   
    const onRequestQuote = async () => {
        /**
         * Story #   : 11694
         * Change #  : Contact Us pop-up for request quote
         * Change by : Pankaj
         * Date      : 21 Dec,2023
         */
        if (orderBlock) {
            openContactUsPopup(true);
            return false;
        }
        const requestedData = get_selected_current_tab_data(quoteList, currentTabSlug);
        if (requestedData && Object.entries(requestedData).length > 0) {
            setNoResultForRFQ(false)
            store.dispatch(system_notification({
                name: 'ValidateRFQQuoteRequest',
                data: {
                    quoteFrom: 'Quote',
                    quoteList: requestedData
                },
            }));

        } else {
            setNoResultForRFQ(true)
        }

    };

    const onBuyNow = async () => {
        if (_check_p('QT_BUY_NOW').status === false) {
            openContactUsPopup();
            return false;
        }

        const approveData = get_selected_current_tab_data(quoteList, currentTabSlug);
        if (approveData && Object.entries(approveData).length > 0) {
            let data = { quoteNumber: quoteNumber, list: approveData }
            // Get approve data and set for buy now
            select_all_quantity(data);
            quoteCartAdditionEvent(approveData)
            window.location.href = CartConfig.getQuoteCartPageRouteURL() + '?quote_number=' + quoteNumber;
        } else {
            setNoResultForCheckout(true)
        }
    };

    const getContactUsButton = () => {
        return (
            <button onClick={() => {
                openContactUsPopup()
            }}
                className='bs5 btn btn-primary click-to-quote-btn mb-2'
            >Contact Us
            </button>
        )
    };
    
    // DT - 13Feb - 9206: Buy now and check box are displaying enable when material is not available for offline quote
    const CheckShowBuyNow = () => {
        if (currentTab === 'A' && currentTabList && Object.entries(currentTabList).length > 0) {
            const isExists = (((Object.values(currentTabList)).find(f => (Helper.valueIsNotNull(f.product?.ERPPartNumber)) === true)) ? true : false);
            if (isExists)
                return true;
            else
                return false;
        }
        return false;
    }

    const btnInfo = () => {
        return <p><i>Please note that purchasing quoted parts will be <br /> a separate transaction from your normal cart.</i> </p>;
    }

    const openContactUsPopup = (val) => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: {
                restrict: val != undefined ? val : false,
                order_block: orderBlock
            },
        }));
    };

    // Added by Ramya
    function quoteCartAdditionEvent(quoteListData) {
        let prodDetails = [];
        let quoteDetails = [];
        Object.entries(quoteListData).map((data,key)=>{
            prodDetails.push(data[1].product);
            quoteDetails.push(data[1])
        })
        prodDetails.map((data,ind)=>{
            let copyObj = {...data};
            copyObj.qas = getInventory(data?.ERPPartNumber)?.qas;
            copyObj.subtotal = (quoteDetails[ind]?.subTotal_quantity_1);
            copyObj.unitPrice = quoteDetails[ind]?.price_quantity_1;
            copyObj.Quantity = quoteDetails[ind]?.quantity_0;
            copyObj.priceSource = getPricing(
              data.ERPMFRPartNumber || data.erpMfrPartNumber,
              data.ERPPartNumber,
              data.ERPPartNumberModified
            )[0]?.priceSource;
            prodDetails[ind] = copyObj;
          })
    
        let cartDetails = {
          additionSource: "PLP",
          cartType: "Quote",
          quoteID :quoteNumber,
          quoteType:"Online"
        };
        localStorage.setItem("adobeEventType", "quoteCartAdditionEvent");
        if (Object.keys(prodDetails).length) {
          HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
        }
      }
    
      //added by Ramya [Adobe script]
      const getInventory = (ERPPartNumber) => {
        if (inventory[ERPPartNumber] !== undefined) {
          return inventory[ERPPartNumber];
        }
        return {
          qas: 0,
          quantity: 0,
        };
      };
      const getPricing = (
        ERPMFRPartNumber,
        ERPPartNumber,
        ERPPartNumberModified
      ) => {
        ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
        if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
          return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
        }
        return [];
      };

    return (
        <>
            <div className="submitted-quote-table mb-5">
                <QuoteDetailSearchFilter />

                {(currentTab === 'A' && noResultForCheckout === true) &&
                    <NoResultContent message={"No quantity is selected. Please select a Quantity to procees to checkout."} isDisplay={false} />
                }
                {((currentTab === 'R' || currentTab === 'B' || currentTab === 'E') && noResultForRFQ === true) &&
                    <NoResultContent message={"No quote is selected. Please select a Quote to proceed"} isDisplay={false} />
                }

                <div className="d-flex justify-content-between align-items-end position-relative">
                    <div className="tabs-text-top d-flex align-items-start text-right position-absolute end-0">
                        {CheckShowBuyNow() === true &&
                            (orderBlock ? getContactUsButton() :
                                <>{btnInfo()}
                                    <button className="bs5 btn btn-primary w95 ms-2"
                                        onClick={() => { onBuyNow() }}
                                    >BUY NOW </button>
                                </>)
                        }
                        {((currentTab === 'R' || currentTab === 'B' || currentTab === 'E') && Object.keys(currentTabList).length > 0) &&
                            <>
                                {btnInfo()}
                                <button className="bs5 btn btn-primary ms-2"
                                    onClick={() => { onRequestQuote() }}
                                >Request New Quote </button>
                            </>
                        }
                    </div>
                    <div className="mobile-tab w-100">
                        <ul className="bs5 nav nav-tabs">
                            {Object.entries(CommonQuoteDetail.chain_QuoteDetailTabList).map((v) => (
                                <React.Fragment key={v[1].name}>
                                    <li className={(statusQuoteDetailTabList == 'PND' && v[1].name != 'PENDING') ? `bs5 nav-item d-none ` : (statusQuoteDetailTabList != 'PND' && v[1].name == 'PENDING') ? `bs5 nav-item d-none ` : 'bs5 nav-item'} key={v[1].name}>
                                        <a className={'nav-link ' + getActiveClass(v[1])}
                                            href={void (0)} onClick={async () => {
                                                await switchTab(getTabLink(v[1]), v[1])
                                            }}
                                        >
                                            <span>{v[1].name} ({v[1].store().count})</span>
                                        </a>
                                    </li>

                                </React.Fragment>
                            ))
                            }
                        </ul>
                    </div>

                </div>

                <div
                    id={CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader].param_value}>
                    {React.createElement(CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader].element, {
                        ...props,
                        current_config: CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader]
                    })}
                </div>
            </div>
        </>
    )
};

export default QuoteDetailTabsListing